import React from 'react';

import NewEntityDialog from './NewEntityDialog';
import NewFormDialog from './NewFormDialog';
import NewReportDialog from './NewReportDialog';
import NewReportModelDialog from './NewReportModelDialog';
import NewSavedSearchDialog from './NewSavedSearchDialog';
import { STANDALONE_DASHBOARD_TYPES } from '../constants/StandaloneLayoutConstants';

const CreateNewItemDialog = ({ dashboardType, isCreateModalOpen, handleCreateModalOpen }) => {
  switch (dashboardType) {
    case STANDALONE_DASHBOARD_TYPES.ENTITIES:
      return <NewEntityDialog open={isCreateModalOpen} handleClose={handleCreateModalOpen} />;
    case STANDALONE_DASHBOARD_TYPES.FORMS:
      return <NewFormDialog open={isCreateModalOpen} handleClose={handleCreateModalOpen} />;
    case STANDALONE_DASHBOARD_TYPES.SAVED_SEARCHES:
      return <NewSavedSearchDialog open={isCreateModalOpen} handleClose={handleCreateModalOpen} />;
    case STANDALONE_DASHBOARD_TYPES.REPORT_MODELS:
      return <NewReportModelDialog open={isCreateModalOpen} handleClose={handleCreateModalOpen} />;
    case STANDALONE_DASHBOARD_TYPES.REPORTS:
      return <NewReportDialog open={isCreateModalOpen} handleClose={handleCreateModalOpen} />;
  }
};

export default CreateNewItemDialog;
